import React from 'react';

import shieldLogin from 'assets/images/new-login/img-mulher.svg';
import shieldOnboarding from 'assets/images/new-login/img-mulher-onboadring.svg';

import AuthLayout from '../AuthLayout';
import { AuthShellVariant, Container, Shield } from './styles';

export type { AuthShellVariant };

type AuthShellProps = {
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  variant?: AuthShellVariant;
};

const SHIELDS: Record<AuthShellVariant, string> = {
  login: shieldLogin,
  onboarding: shieldOnboarding,
};

const AuthShell: React.FC<AuthShellProps> = ({
  children,
  variant = 'login',
}) => {
  return (
    <AuthLayout variant={variant}>
      <Container variant={variant}>
        <Shield
          variant={variant}
          src={SHIELDS[variant]}
          alt=""
          aria-hidden="true"
        />
        {children}
      </Container>
    </AuthLayout>
  );
};

export default AuthShell;
